export const SearchInputData = {
  ServiceType: "AI Agent for Support",
  ApplicationType: "Ecolab3D",
  enableMostRecentSelection: true,
  SearchTabs: [{
    'name': 'COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT',
    'value': 'CorporateAccount',
    'placeholder': 'COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT_PLACEHOLDER',
    'searchFields': ['CorporateAccount'],
    'contextPointIdKeys': ['CorporateAccountId', 'CorporateAccount'],
    'responseFileds': ['*'],
    'displaySecondaryText': false,
    'showDefaultData': false,
    'showActiveData': true,
    'uniqueKey': 'CorporateAccountId',
    'contextPointTypeId': 4000,
    'maxSearchCount': 100,
    'recentsData': [],
    'enableHierarchy': false,
    'showRecents': true,
    'enableCustomerDivisionSelection': false,
    'enableMultiLevelSearchInContext': false,
  },
  {
    'name': 'COMMON.GLOBAL_SEARCH.SITES',
    'value': 'Site',
    'placeholder': 'COMMON.GLOBAL_SEARCH.SITES_PLACEHOLDER',
    'searchFields': ['Site', 'Street', 'City', 'PostalCode', 'StateProvince', 'Accounts{Territory, SalesAccount,SoldTos{SoldTo}}'],
    'responseFileds': ['*'],
    'contextPointIdKeys': ['SiteId', 'Site'],
    'displaySecondaryText': true,
    'uniqueKey': 'SiteId',
    'contextPointTypeId': 5000,
    'maxSearchCount': 100,
    'showDefaultData': false,
    'showFavouriteData': false,
    'showActiveData': true,
    'showRecents': true,
    'enableMultiLevelSearchInContext': false,
    'recentsData': [],
    'enableHierarchy': false,
  }
  ],
}
